import React from 'react';
import './CaptchaModal.css';

const CaptchaModal = ({
  isOpen,
  captchaImage,
  captchaInput,
  onInputChange,
  onRefresh,
  onSubmit,
  onClose,
  loading,
  error,
}) => {
  if (!isOpen) return null;

  return (
    <div className="captcha-modal-overlay">
      <div className="captcha-modal">
        <h2>Проверка на бота</h2>
        <p>Введите текст или ответ из картинки</p>

        {loading ? (
          <p>Загрузка капчи...</p>
        ) : (
          <>
            <img
              src={captchaImage}
              alt="captcha"
              className="captcha-image"
              onClick={onRefresh}
              title="Нажмите для обновления"
            />
            <input
              type="text"
              value={captchaInput}
              onChange={onInputChange}
              placeholder="Ответ"
              className="captcha-input"
            />
            {error && <div className="captcha-error">{error}</div>}
          </>
        )}

        <div className="captcha-actions">
          <button onClick={onSubmit} className="submit-btn">Далее</button>
          <button onClick={onClose} className="cancel-btn2">Отмена</button>
        </div>
      </div>
    </div>
  );
};

export default CaptchaModal;
